import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { UserService } from 'src/app/services/user.service';
import { Options } from 'select2';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid';
import * as JSZip from 'jszip';

declare var bootstrap: any;
declare var Resumable: any;

@Component({
  selector: 'app-nfe',
  templateUrl: './nfe.component.html',
  styleUrls: ['./nfe.component.css']
})
export class NfeComponent implements OnInit {
  isOK = false;

  @ViewChild('upload1')
  file1!: ElementRef;

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {};

  cadastroFrm: cadastroData = {
    loading: false,
    data: {
      cliente: -1,
      planilha: null as unknown as File,
      senha: '',
      progresso: 0
    }
  }

  logs: Array<logsData> = [];

  modalCadastrar: any;
  modalLog: any;

  resumable: any;

  options1!: Options;

  constructor(public userService: UserService, private router: Router) { }

  ngOnInit(): void {
    if (this.userService.checarPermissao('14')[0]) {
      this.isOK = true;
    } else {
      return;
    }

    this.dtOptions = {
      language: this.userService.dataTableLanguage,
    }

    this.modalCadastrar = new bootstrap.Modal(
      document.getElementById('cadastrar'),
      {
        backdrop: 'static',
      }
    );

    this.modalLog = new bootstrap.Modal(
      document.getElementById('log'),
      {
        backdrop: 'static',
      }
    );

    this.options1 = {
      allowClear: true,
      placeholder: 'Selecione um Cliente',
      ajax: {
        type: 'POST',
        url: environment.apiEndpoint + 'select-cliente',
        dataType: 'json',
        contentType: "application/json",
        headers: {
          Authorization: 'Bearer ' + this.userService.getToken(),
        },
        delay: 250,
        data: (params) => {
          return JSON.stringify({
            q: params.term,
          });
        },
        error: (xhr: any) => {
          if (xhr.status === 401) {
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
          }
        },
        processResults: (data) => {
          return {
            results: data,
          };
        },
        cache: true,
      },
      language: "pt-BR",
      dropdownParent: $('#cadastrar')
    };

    this.dtOptions = {
      language: this.userService.dataTableLanguage,
      ajax: {
        url: environment.apiEndpoint + 'importacao-nfe-list',
        type: 'POST',
        dataType: 'json',
        contentType: "application/json",
        data: function (d) {
          return JSON.stringify(d);
        },
        headers: {
          Authorization: 'Bearer ' + this.userService.getToken(),
        },
        error: (xhr: any, error: any, code: any) => {
          if (xhr.status === 401) {
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
          }
        }
      },
      pageLength: 10,
      processing: false,
      serverSide: true,
      columnDefs: [
        { "searchable": false, "targets": [6] },
        { "orderable": false, "targets": [6] },
      ],
      order: [[1, 'desc']],
      rowCallback: (row: Node, data: any[] | object, index: number) => {
        const id = Number($('button:eq(0)', row).attr('row_id'));
        $('button:eq(0)', row).off('click');
        $('button:eq(0)', row).on('click', (obj) => {
          const call = async () => {
            (obj.currentTarget as any).disabled = true;
            obj.currentTarget.innerHTML = '<span class="spinner-border spinner-border-sm"></span>';
            await this.fetchDownload(id);
            (obj.currentTarget as any).disabled = false;
            obj.currentTarget.innerHTML = '<i class="bi bi-download"></i>'
          }
          call();
        });
        $('button:eq(1)', row).off('click');
        $('button:eq(1)', row).on('click', (obj) => {
          const call = async () => {
            (obj.currentTarget as any).disabled = true;
            obj.currentTarget.innerHTML = '<span class="spinner-border spinner-border-sm"></span>';
            await this.fetchLog(id);
            (obj.currentTarget as any).disabled = false;
            obj.currentTarget.innerHTML = '<i class="bi bi-search"></i>';
          }
          call();
        });
        return row;
      },
    }
  }

  Cadastrar() {
    if (this.cadastroFrm.data.planilha) {
      this.resumable = new Resumable({
        chunkSize: 1 * 1024 * 1024,
        simultaneousUploads: 1,
        testChunks: false,
        throttleProgressCallbacks: 1,
        target: environment.apiEndpoint + 'cadastrar-importacao-nfe',
        query: {
          cliente: this.cadastroFrm.data.cliente,
          senha: this.cadastroFrm.data.senha
        },
        generateUniqueIdentifier: (file: File, event: any) => {
          return uuidv4();
        },
        headers: { Authorization: `Bearer ${this.userService.getToken()}`, }
      });
      if (!this.resumable.support) {
        Swal.fire({
          title: 'Erro',
          text: String('O navegador não tem suporte à envios de arquivos através de HTML5.'),
          icon: 'error',
          heightAuto: false,
          allowOutsideClick: false,
          focusConfirm: false,
          customClass: {
            confirmButton: 'btn-swal'
          },
        });
      } else {
        this.resumable.on('fileAdded', (file: any) => {
          this.resumable.upload();
          this.cadastroFrm.loading = true;
        });
        this.resumable.on('fileSuccess', (file: any, message: any) => {
          Swal.fire({
            title: 'Sucesso',
            text: 'Importação registrada',
            icon: 'success',
            heightAuto: false,
            allowOutsideClick: false,
            focusConfirm: false,
            customClass: {
              confirmButton: 'btn-swal'
            },
          });
          this.cadastroFrm.data = {
            cliente: -1,
            planilha: null as unknown as File,
            senha: '',
            progresso: 0
          };
          this.cadastroFrm.loading = false;
          this.file1.nativeElement.value = "";
          this.modalCadastrar.hide();
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.ajax.reload();
          });
          this.resumable = null;
        });
        this.resumable.on('error', (message: any, file: any) => {
          Swal.fire({
            title: 'Erro',
            text: String(JSON.parse(message)['error']),
            icon: 'error',
            heightAuto: false,
            allowOutsideClick: false,
            focusConfirm: false,
            customClass: {
              confirmButton: 'btn-swal'
            },
          });
          this.resumable = null;
          this.cadastroFrm.loading = false;
        });
        this.resumable.on('fileProgress', (file: any) => {
          this.cadastroFrm.data.progresso = Number((this.resumable.progress() * 100).toFixed(2));
        });
        this.resumable.addFile(this.cadastroFrm.data.planilha);
      }
    }
    /*
    case 401:
      localStorage.removeItem('botway');
      this.router.navigate(['/login']);
      break;
    */
  }

  fetchDownload(id: number) {
    return new Promise((resolve) => {
      this.userService.fetchDownloadImportacaoNFe(id).subscribe(
        (res: any) => {
          window.open(res.link, '_blank')!.focus();
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
        },
      ).add(() => {
        resolve('');
      });
    });
  }

  fetchLog(id: number) {
    return new Promise((resolve) => {
      this.userService.fetchLogImportacaoNFe(id).subscribe(
        (res: any) => {
          this.logs = res.log;
          this.modalLog.show();
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
        },
      ).add(() => {
        resolve('');
      });
    });
  }

  async handleUpload(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.files && target.files.length) {
      const file = target.files[0];
      if (file) {
        let result = await JSZip.loadAsync(file)
          .then(function (zip) {
            let isTXT = false;
            zip.forEach(function (relativePath, zipEntry) {
              if ('xml' === zipEntry.name.split('.').pop()) {
                isTXT = true;
              }
            });
            return isTXT;
          }, function (e) {
            return false;
          });
        if (result) {
          this.cadastroFrm.data.planilha = file;
        } else {
          this.cadastroFrm.data.planilha = null as unknown as File;
          this.file1.nativeElement.value = "";
          Swal.fire({
            title: 'Erro',
            html: 'O arquivo ZIP selecionado possuí arquivos inválidos. Por favor, consulte o manual',
            icon: 'error',
            heightAuto: false,
            allowOutsideClick: false,
            focusConfirm: false,
            customClass: {
              confirmButton: 'btn-swal'
            },
          });
        }
      } else {
        this.cadastroFrm.data.planilha = null as unknown as File;
      }
    }
  }

  returnWidth() {
    return 'width: ' + this.cadastroFrm.data.progresso + '%';
  }
}

export interface cadastroData {
  loading: boolean;
  data: {
    cliente: Number;
    planilha: File;
    senha: string;
    progresso: Number;
  }
}

export interface logsData {
  date: string;
  log: string;
}
